import { render, staticRenderFns } from "./view.vue?vue&type=template&id=0b007dac&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b007dac')) {
      api.createRecord('0b007dac', component.options)
    } else {
      api.reload('0b007dac', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=0b007dac&", function () {
      api.rerender('0b007dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/view.vue"
export default component.exports